import { PayloadAction } from '@reduxjs/toolkit';
import { initialState } from './index';
import { AttributesPayload, Attributes } from './types';

export const reducers = {
  getAttributes(state, action: PayloadAction<AttributesPayload>) {
    state.isLoading = true;
  },
  getAttributesSuccess(state, action: PayloadAction<Attributes>) {
    state.isLoading = false;
    state.error = null;
    state.data = action.payload;
  },
  getAttributesFail(state, action: PayloadAction<unknown>) {
    state.isLoading = false;
    state.data = initialState.data;
    state.error = action.payload;
  },
};
